// Общие
export const MAIN_PAGE = '/'

// Компания
export const ABOUT_COMPANY_PAGE = '/about'
export const SUPPORT_PAGE = '/support'
export const CAREERS_PAGE = '/careers'
export const VACANCY_DETAILS_PAGE = '/careers/details'
export const CONTACTS_PAGE = '/contacts'
export const NEWS_PAGE = '/news'

// Недвижимость
export const PROJECTS_PAGE = '/projects'
export const BUSINESS_PAGE = '/business'
export const PARKING_PAGE = '/parking'
export const PROJECT_STATUS_PAGE = '/projects/status'
export const CONSTRUCTION_PROGRESS_PAGE = '/projects/progress'
export const BUSINESS_PROJECT_PAGE = '/business/status'
export const BUSINESS_CARD_PAGE = '/business/status/:id'
export const PARKING_PROJECT_PAGE = '/parking/status'
export const PARKING_CARD_PAGE = '/parking/status/:id'

// Сервисы
export const PROMO_PAGE = '/promo'
export const MORTGAGE_PAGE = '/mortgage'
export const EXCURSIONS_PAGE = '/excursions'

export const FLATS_PAGE = '/flat/status'
export const FLAT_PAGE = '/flat/status/:id'

export const FAVORITE_PAGE = '/favorite'
export const COMPARE_PAGE = '/compare'

export const MANAGEMENT_PAGE = '/management'

export const PRIVACY_PAGE = '/privacy'
export const TERMS_PAGE = '/terms'
export const AGREEMENT_PAGE = '/agreement'

export const PURCHASE_FLAT_PAGE = '/flat/status/:id/buy'
export const PURCHASE_BUSINESS_PAGE = '/business/status/:id/buy'
export const PURCHASE_PARKING_PAGE = '/parking/status/:id/buy'
